import { useState, useEffect } from "react";
import { Shield } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const consent = localStorage.getItem("st_cookie_consent");
    if (consent) return;
    // iter80.7: Authentifizierte User haben durch Login-Zustimmung bereits die
    // notwendigen Cookies akzeptiert → auto-set ESSENTIAL, damit das Banner
    // nicht dauerhaft Bottom-CTAs überlagert.
    if (user && user !== false) {
      localStorage.setItem("st_cookie_consent", JSON.stringify({
        level: "ESSENTIAL", date: new Date().toISOString(), auto: true,
      }));
      return;
    }
    setVisible(true);
  }, [user]);

  const accept = (level) => {
    localStorage.setItem("st_cookie_consent", JSON.stringify({ level, date: new Date().toISOString() }));
    setVisible(false);
  };

  useEffect(() => {
    // iter252 · Body-Padding solange Banner sichtbar (verhindert Verdeckung
    // unterer Buttons wie Add-Cart/Chat).
    if (visible) {
      const prev = document.body.style.paddingBottom;
      document.body.style.paddingBottom = "180px";
      return () => { document.body.style.paddingBottom = prev; };
    }
    return undefined;
  }, [visible]);

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-[60] bg-[#0A0A0A] text-white border-t border-[#333] shadow-2xl">
      <div className="max-w-md mx-auto px-4 py-4">
        <div className="flex items-start gap-3">
          <Shield size={18} className="text-[#C0C0C0] mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-white">{t("cookie_banner.title")}</p>
            <p className="text-[10px] text-[#888] mt-1 leading-relaxed">
              {t("cookie_banner.body")}
            </p>
            <div className="flex gap-2 mt-3">
              <button
                data-testid="cookie-accept-all"
                onClick={() => accept("ALL")}
                className="h-8 px-4 bg-white text-[#0A0A0A] text-[11px] font-medium transition-colors hover:bg-[#E5E5E5] active:scale-[0.97]"
              >
                {t("cookie_banner.accept_all")}
              </button>
              <button
                data-testid="cookie-accept-essential"
                onClick={() => accept("ESSENTIAL")}
                className="rounded-full h-8 px-4 border border-[#444] text-[11px] text-[#888] transition-colors hover:border-[#666] hover:text-white active:scale-[0.97]"
              >
                {t("cookie_banner.accept_essential")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
